/** Single source for localStorage keys — do not scatter strings in the app. */
export const STORAGE_KEYS = {
  TOKEN: 'cms_admin_token',
  USER: 'cms_admin_user',
  DASH_SIDEBAR: 'cms_dash_sidebar',
  SITE_LANGUAGE: 'tevris_site_language',
};

export const DASH_SIDEBAR_KEY = STORAGE_KEYS.DASH_SIDEBAR;
